package gr.tech.meetinggenie.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.styles.ButtonStyle
import gr.tech.meetinggenie.styles.CloseIconStyle
import gr.tech.meetinggenie.styles.ModalCardStyle
import gr.tech.meetinggenie.styles.ModalSubtitleStyle
import gr.tech.meetinggenie.styles.ModalTitleStyle
import gr.tech.meetinggenie.styles.SecondaryButtonStyle
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ConfirmModal(
    actionText: String,
    subText: String = "",
    onConfirm: () -> Unit,
    onDismiss: () -> Unit
) {
    ModalOverlay(isOpen = true, onClose = onDismiss) {
        Column(
            modifier = ModalCardStyle.toModifier()
                .padding(1.cssRem)
                .width(min(700.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaX(modifier = CloseIconStyle.toModifier().onClick { onDismiss() })
            }

            H2(attrs = ModalTitleStyle.toModifier().toAttrs()) {
                Text("Are you sure you want to '$actionText'?")
            }

            H3(attrs = ModalSubtitleStyle.toModifier().toAttrs()) {
                Text(subText)
            }

            Row(modifier = Modifier.gap(16.px).fillMaxWidth()) {
                Button(
                    attrs = SecondaryButtonStyle.toModifier()
                        .onClick { onDismiss() }
                        .toAttrs()
                ) { Text("Cancel") }

                Spacer()

                Button(
                    attrs = ButtonStyle.toModifier()
                        .onClick { onConfirm() }
                        .toAttrs()
                ) { Text("Confirm") }
            }
        }
    }
}
